export type PaymentAttempt = { invoiceId: number; key: string };

export function paymentAttemptForInvoice(
  current: PaymentAttempt | null,
  invoiceId: number,
  generateKey: () => string = () => crypto.randomUUID(),
): PaymentAttempt {
  return current?.invoiceId === invoiceId ? current : { invoiceId, key: generateKey() };
}
